import { useContext, useState, useEffect } from 'react'
import { createUser } from '../../context/authContext/apiCalls'
import { AuthContext } from '../../context/authContext/AuthContext'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import './signup.css'
const Signup = () => {
  const { isFetching, message, error, dispatch, user } = useContext(AuthContext)
  const [phoneValue, setPhoneValue] = useState()

  const [postData, setPostData] = useState({
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: phoneValue,
    Password: '',
    AffiliateID: '',
    isAdmin: false
  })

  const handleChange = (e) => {
    const { name, value } = e.target

    setPostData({ ...postData, [name]: value })
  }
  const handleSignUp = async (e) => {
    e.preventDefault()

    const data = {
      FirstName: postData.FirstName.trim(),
      LastName: postData.LastName.trim(),
      Email: postData.Email.trim(),
      Phone: phoneValue ? phoneValue : postData.Phone,
      Password: postData.Password.trim(),
      AffiliateID: postData.AffiliateID.trim(),
      Status: true,
      isAdmin: user && user.result.isAdmin === true ? true : false
    }

    await createUser({ data }, dispatch)
  }
  useEffect(() => {
    if (message) {
      alert(message.message.data.message)
    }
    console.log(user)
  }, [message, user])
  return (
    <div className='login'>
      <form className='loginForm'>
        <div className='twoColumn'>
          <input
            type='text'
            placeholder='First Name'
            name='FirstName'
            className='loginInput'
            value={postData.FirstName || ''}
            onChange={(e) => handleChange(e)}
          />
          <input
            type='text'
            placeholder='Last Name'
            className='loginInput'
            name='LastName'
            value={postData.LastName || ''}
            onChange={(e) => handleChange(e)}
          />
        </div>
        <PhoneInput
          disableCountryCode={true}
          placeholder='Enter phone number'
          value={postData.Phone}
          country={'us'}
          onlyCountries={['us']}
          masks={{ us: '(...) ...-....' }}
          onChange={(phone) => setPhoneValue(phone)}
        />

        <input
          type='text'
          placeholder='Email'
          className='loginInput'
          name='Email'
          value={postData.Email || ''}
          onChange={(e) => handleChange(e)}
        />
        <input
          type='password'
          placeholder='Password'
          className='loginInput'
          autoComplete='true'
          name='Password'
          value={postData.Password || ''}
          onChange={(e) => handleChange(e)}
        />
        <button
          className='loginButton'
          onClick={handleSignUp}
          disabled={isFetching}
        >
          Sign Up
        </button>
        {error ? 'Wrong email or password! Please try again!' : null}
      </form>
    </div>
  )
}

export default Signup
